module.exports = __webpack_public_path__ + "img/duome-logo-blacklogo.67808705.svg";